import { Spinner } from 'components/loaders/Spinner'
import { useInView } from 'react-intersection-observer'

interface ContentProps {
  hasNextPage: boolean
  isFetchingNextPage: boolean
  onNextPage: () => void
}

export const Content = ({
  hasNextPage,
  isFetchingNextPage,
  onNextPage,
}: ContentProps) => {
  const { ref } = useInView({ onChange: (inView) => inView && onNextPage() })

  if (isFetchingNextPage) return <Spinner className="text-2xl" />
  if (!hasNextPage) return null

  return <div ref={ref} />
}

interface WrapperProps {
  numOfColumns: number
}

export const ScrollableTableBottom = ({
  numOfColumns,
  ...contentProps
}: WrapperProps & ContentProps) => (
  <tr>
    <td colSpan={numOfColumns} className="p-6 text-center border-none">
      <Content {...contentProps} />
    </td>
  </tr>
)
